import { render, staticRenderFns } from "./cw-configuration-wizard.vue?vue&type=template&id=a2fd2824&"
import script from "./cw-configuration-wizard.vue?vue&type=script&lang=tsx&"
export * from "./cw-configuration-wizard.vue?vue&type=script&lang=tsx&"
import style0 from "./cw-configuration-wizard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports